import isString from 'lodash/isString';



const getUrlPathnamePrefix = (pathname, exclusion = 'dictionaries') => {
  if (!pathname || !isString(pathname)) {
    return null;
  }

  const pathSource = pathname.split('/')[1];

  return pathSource !== exclusion ? pathSource : null;
};

export default getUrlPathnamePrefix;
